/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Content/view.blocks to change it.
import * as fromDesignTokens from 'Simple/DesignTokens'
import * as fromFlow from 'Simple/Flow'
import Boards from './Boards/index'
import React from 'react'
import ToggleIcon from './ToggleIcon/index'
import TysiaText from 'DesignSystem/TysiaText/index'
import Tysiav2ArchivedBoardsIcon from 'DesignSystem/Svgs/Tysiav2ArchivedBoardsIcon/index'
import styles from './view.module.css'



/** @type {import('Simple/types.js').View} */
export default function Content({
  children,
  viewPath = "/App/Account/Content/Tasks/New/Menu/Expanded/BoardsArchived/Content"
  
}) {
  let flow = fromFlow.useFlow()
  let setFlowTo = fromFlow.useSetFlowTo(viewPath)
let dtSpaceS = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.s'
        })
let dtSpaceLs = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.ls'
        })
let dtSpaceXs = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.xs'
        })
  return (<React.Fragment
>
<button
  data-testid="Content.Horizontal"
  data-view-path={viewPath}
 onClick={flow.has(fromFlow.normalizePath(viewPath, 'Boards/Content')) ? () => setFlowTo(fromFlow.normalizePath(viewPath, 'Boards/No')) : () => setFlowTo(fromFlow.normalizePath(viewPath, 'Boards/Content'))}
 style={{'--ml-1-Z1Yf8zk': typeof dtSpaceS === 'number' ? `${dtSpaceS}px` : dtSpaceS,'--mr-2-Z1Yf8zk': typeof dtSpaceS === 'number' ? `${dtSpaceS}px` : dtSpaceS,'--mt-3-Z1Yf8zk': typeof dtSpaceLs === 'number' ? `${dtSpaceLs}px` : dtSpaceLs}}
 className={`views-block ${styles.Horizontal}`}
>
<div
  data-testid="Content.Horizontal:1"
  data-view-path={viewPath}
 className={`views-block ${styles.Horizontal1}`}
>
<Tysiav2ArchivedBoardsIcon
  viewPath={`${viewPath}/Tysiav2ArchivedBoardsIcon`}
/>
<TysiaText
  viewPath={`${viewPath}/TysiaText`}
 weight="medium"
 size="normal"
 marginLeft={dtSpaceXs}
 text="Archived"
/>
</div>
<div
  data-testid="Content.Horizontal:2"
  data-view-path={viewPath}
 className={`views-block ${styles.Horizontal2}`}
>
<ToggleIcon
  viewPath={`${viewPath}/ToggleIcon`}
/>
</div>
</button>
<Boards
  viewPath={`${viewPath}/Boards`}
/>
{children}
</React.Fragment>)
}